export default __webpack_public_path__ + "static/media/Sad0.874b1ee7.png";